import CreateNewPasswordForm from './CreateNewPasswordForm'

export default CreateNewPasswordForm
